import Component from './component';
import { makeDefault } from './defaults';
import { isValidData } from './validator';

export const Gif = { Component, makeDefault, isValidData } as const;
export type { GifData } from './types';
